import { Component } from '@angular/core';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ui-gallery',
  templateUrl: './ui-gallery.component.html',
  styleUrls: ['./ui-gallery.component.scss'],
})
export class UiGalleryComponent {
  model!: NgbDateStruct;
  constructor(private ngbDateParserFormatter: NgbDateParserFormatter) {}

  getFormattedDate(date: NgbDateStruct): string {
    if (!date) return '';
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = days[jsDate.getDay()];
    const month = months[jsDate.getMonth()];
    const year = jsDate.getFullYear();

    // Formatted date string
    return `${day}, ${month} ${jsDate.getDate()}`;
  }

  ngOnInit() {
    window.scrollBy(1, 1);
  }

  peopleSelect!: number;
  timeSelect!: number;
  peoples = [
    { id: 1, name: '2 people' },
    { id: 2, name: '4 people' },
    { id: 3, name: '8 people' },
  ];

  times = [
    { id: 1, name: '8:00 pm' },
    { id: 2, name: '9:00 pm' },
    { id: 3, name: '10:00 pm' },
  ];

  active = 1;
}
